export const isResidentialClient = (comOrRes: string | null | undefined): boolean => comOrRes?.toUpperCase() === 'R';

export const isResidentialSuppressed = (comOrRes: string | null | undefined, includeResidential: boolean): boolean =>
  !includeResidential && isResidentialClient(comOrRes);
